import Collections from '../utils/collections';
import BaseDocument from './BaseDocument';

export const UserExerciseOverrideSource = {
  CLIENT: 'CLIENT',
  AC: 'AC',
};

export const UserExerciseOverrideAction = {
  REMOVE: 'REMOVE',
  REPLACE: 'REPLACE',
};

class UserExerciseOverrides extends BaseDocument {
  constructor(userId, opts) {
    super(`${Collections.USER_EXERCISE_OVERRIDES}/${userId}`, opts);
  }

  get activeEntries() {
    return Object.entries(this.data || {})
      .filter(([, value]) => !!value?.active)
      .map(([originalExerciseId, value]) => ({
        originalExerciseId,
        ...value.active,
      }));
  }
}

export default UserExerciseOverrides;
